module.exports = __webpack_public_path__ + "img/ld3.d0b73a9c.jpg";